import { ISkillItem } from '@typings/store/skill.interface';
import { IstoreItem } from '@typings/store/storeItem.interface';
import React from 'react';
import styled from 'styled-components';
import ItemTypeSec from './ItemTypeSec';
import { replaceContents } from '@utils/replaceContents';
import PhotocardMiniTag from './PhotocardMiniTag';
import WalletPrice from '@pages/Store/component/WalletPrice';
import ItemImgCard from '@components/dataDisplay/Store/ItemImgCard';

const ContentsSec = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 0;

  h6 {
    font-size: 18px;
  }
`;

const Contents = styled.div`
  background-color: var(--cardBackgroundColor);
  border-radius: var(--cardBorderRadius);
  border: 1px solid var(--lineColor);
  padding: 8px 16px;
  p {
    font-size: 13px;
    line-height: 1.4;
  }
`;

const ImgSec = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DescriptionSec = styled.div`
  padding: 4px;

  p {
    font-size: 12px;
    line-height: 1.4;
    color: var(--subTextColor);
  }
`;

const GiftMsgSec = styled.div`
  background: var(--backgroundColor);
  border-radius: var(--cardBorderRadius);
  border: 1px solid var(--primaryColor);
  padding: 12px 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;

  p {
    font-size: 14px;
    line-height: 1.4;
  }
`;

type Props = {
  data?: IstoreItem | ISkillItem | any;
  showWallet?: boolean;
  amount?: number;
};
function ItemInfoSec({ data, showWallet, amount }: Props) {
  const { title, description, contents } = data;

  return (
    <>
      <ImgSec>
        <ItemImgCard data={data} />
      </ImgSec>
      <ContentsSec>
        <h6>{title}</h6>
        <ItemTypeSec data={data} />
        {description && (
          <DescriptionSec>
            <p
              dangerouslySetInnerHTML={{
                __html: replaceContents(description),
              }}
            />
          </DescriptionSec>
        )}
        {contents && (
          <Contents>
            <p
              dangerouslySetInnerHTML={{
                __html: replaceContents(contents),
              }}
            />
          </Contents>
        )}
        {data.giftMessage && (
          <GiftMsgSec>
            <p
              dangerouslySetInnerHTML={{
                __html: replaceContents(`"${data.giftMessage}"`),
              }}
            />
            <PhotocardMiniTag photocardID={data.giftingCharID} />
          </GiftMsgSec>
        )}

        {showWallet && (
          <WalletPrice price={Number(data.price) * (amount || 1)} showMyWalet />
        )}
      </ContentsSec>
    </>
  );
}

export default ItemInfoSec;
